<!-- 在线客服左侧列表 -->
<template>
  <div class="rightdata">
    <Card :bordered="false" :padding="0">
      <Tabs v-model="tabRig" @on-click="changeTabrig">
            <TabPane label="客户资料" name="1" :style="heightStyle">

                <div class="tabRig-top" style="position: absolute;z-index:999999">
                  <div class="tabRig-topleft">
                        <div style="line-height: 28px;font-size:14px">
                          <span>客户信息</span>
                          <a href="javascript:void(0)" @click="handleOpen">
                            <Icon type="ios-arrow-up" v-if="!visible"></Icon>
                            <Icon type="ios-arrow-down" v-if="visible"></Icon>
                          </a>
                        </div>
                  </div>
                  <Button type="primary" :disabled="openId ? false : true" class="btn" style="height: 25px;" @click="beforeSave()">保存</Button>
                </div>

                <Form :model="showColumnList" class="rightForm" :label-colon="true" :show-message="false" label-position="right" :rules="showColumnList.customerRule">
                    <FormItem :label="item.customName" :title="item.customName" :prop="item.customColName" v-for="(item,index) in showColumnList.columnList"
                        v-if="item.customColName!='createTime' && item.customColName!='lastConnectTime' && item.customColName!='allocateTime' && item.customColName!='shareTime' && item.customColName!='shareStatus' && item.customColName!='creator' && item.customColName!='status'"
                        :key="index" v-show="item.customIsShow == '1' || visible">
                        <Input v-if="item.type=='text' " v-model="item.customValue" :disabled="item.customIsAlter!='1'"/>
                        <Input v-if="item.type == 'textarea'" type="textarea" :rows="3" v-model="item.customValue" :disabled="item.customIsAlter!='1'"/>
                        <Input v-if="item.type=='number'"  type="number"  v-model="item.customValue" title="只能输入数字" :disabled="item.customIsAlter!='1'"/>
                        <el-date-picker v-if="item.type=='datetime'" transfer="true" v-model="item.customValue" type="datetime" :title="item.customName" align="left" :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
                        <Select v-if="item.type=='select' || item.type=='radio'"  v-model="item.customValue" :transfer="true"  clearable  :disabled="item.customIsAlter!='1'">
                            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
                        </Select>
                        <Select v-if="item.type=='checkbox'" v-model="item.customValue"   clearable multiple :transfer="true" :max-tag-count="3"  :disabled="item.customIsAlter!='1'">
                            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
                        </Select>
                        <el-cascader  clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>
                        <File v-if="item.type=='file'" @fileUploadCallback="fileUploadCallback" v-model="item.customValue" :disabled="item.customIsAlter!='1'" style="width:98%" :showFilelist= "true"/>

                    </FormItem>
                </Form>

                <div v-if="'0' == configInfo.isHiddenService" class="tabRig-top">
                  <div class="tabRig-topleft">
                        <div style="line-height: 28px;font-size:14px">
                          <span>服务信息</span>
                          <a href="javascript:void(0)" @click="handleOpenService">
                            <Icon type="ios-arrow-up" v-if="!visibleService"></Icon>
                            <Icon type="ios-arrow-down" v-if="visibleService"></Icon>
                          </a>
                        </div>
                  </div>

                </div>
                <Form v-if="'0' == configInfo.isHiddenService" class="rightForm" :model="showColumnList" style="margin-top:10px" :label-colon="true" :show-message="false" label-position="right" :rules="showColumnList.serviceRule">
                    <FormItem :label="item.customName" :title="item.customName"
                    v-if="item.customColName!='customerId' && item.customColName!='employeeId' && item.customColName!='serviceNextTime' && item.customColName!='createTime'"
                    :prop="item.customColName" v-for="(item,index) in showColumnList.serviceList" :key="index" :class="{'teleFormStyle':item.type=='file' || item.type=='textarea'}"
                    v-show="item.customIsShow == '1' || visibleService">
                      <Input v-if="item.type=='text'" v-model="item.customValue" :disabled="item.customIsAlter!='1'"/>

                      <Input  v-if="item.type=='textarea'" type="textarea" :rows="3" v-model="item.customValue" :disabled="item.customIsAlter!='1'"/>

                      <el-date-picker v-model="item.customValue" type="datetime" :title="item.customName" align="left" :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

                      <Select v-if="item.type=='select' || item.type=='radio'" :transfer="true" clearable v-model="item.customValue" >
                        <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
                      </Select>

                      <Select v-if="item.type=='checkbox'" clearable multiple :transfer="true" :max-tag-count="3" v-model="item.customValue"  :disabled="item.customIsAlter!='1'">
                        <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
                      </Select>

                      <el-cascader  clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

                      <Input v-if="item.type=='number'" type="number" title="只能输入数字" v-model="item.customValue" :disabled="item.customIsAlter!='1'"/>

                      <File v-if="item.type=='file'" @fileUploadCallback="fileUploadCallback" v-model="item.customValue" :disabled="item.customIsAlter!='1'" style="width:98%" :showFilelist= "true"/>
                    </FormItem>
                </Form>

            </TabPane>
            <TabPane label="会话信息" name="2" :disabled="openId ? false : true">
                <!-- <div class="sessionInfo-title">
                  会话信息
                </div> -->
                <div class="sessionInfo-con">
                  <div class="info-con-one">
                    <p class="one-key">访客渠道:</p>
                    <p class="one-value">{{visitorFrom}}</p>
                  </div>
                  <div class="info-con-one">
                    <p class="one-key">地区&IP:</p>
                    <p class="one-value">{{ipArea}}</p>
                  </div>
                  <div hidden class="info-con-one">
                    <p class="one-key">会话时间:</p>
                    <p class="one-value"></p>
                  </div>
                  <div class="info-con-one">
                    <p class="one-key">受理座席:</p>
                    <p class="one-value">{{customerManager}}</p>
                  </div>
                  <div hidden class="info-con-one">
                    <p class="one-key">正在访问的URL:</p>
                    <p class="one-value">{{browseUrl}}</p>
                  </div>
                    <div class="info-con-one">
                    <p class="one-key">来访次数:</p>
                    <p class="one-value">{{visitedtimes}}</p>
                  </div>
                  <div hidden class="info-con-one">
                    <p class="one-key">排队时间:</p>
                    <p class="one-value"></p>
                  </div>
                  <div hidden class="info-con-one">
                    <p class="one-key">浏览时间:</p>
                    <p class="one-value"></p>
                  </div>
                </div>
                <div class="locus-title">
                  咨询轨迹
                </div>
                <div class="locus-con" style="height:500px">
                      <Timeline>
                        <TimelineItem v-for="(item, index) in trajecnumList" :key="index">
                            <p >{{item.visitorName}}</p>
                            <p >访客渠道:<span>{{item.visitorFrom}}</span></p>
                            <p >服务记录:<span>{{item.serviceDescr}}</span></p>
                            <p >{{item.createTime}}</p>
                        </TimelineItem>
                      </Timeline>
                </div>
            </TabPane>
            <TabPane label="工单信息" v-if="'1' == sysSupportWorkOrder" :disabled="openId ? false : true" name="4">
            </TabPane>
            <TabPane label="快捷回复" name="3" id="lib">
                <el-tabs type="border-card" v-model="librarytype" @tab-click="changlib">
                  <el-tab-pane label="个人库" class="library" name="1" >
                      <div class="personseach">
                        <input placeholder="请输入内容搜索" v-model="seachwords"/>
                        <i data-v-d2fd4914="" class="el-input__icon el-icon-search" style="height:40px;position:absolute;" @click="searchfast"></i>
                      </div>
                      <div class="quickreply">
                          <div class="classify">
                                <div class="classify-title">分类</div>
                                <div class="classify-con" :style="classifyHeight">
                                  <div class="ztree" id="sortTree"></div>
                                </div>
                          </div>
                          <div class="content">
                                <div class="content-title">
                                  内容
                                  <Button type="primary" size="small" :disabled="selectedTreeName == '根目录'" @click="addcontent" style="float:right;margin-top:10px">添加话术</Button>
                                </div>
                                <div class="content-con" :style="classifyHeight">
                                   <div v-for="(item, index) in contentGroup" :key="index" :id="item.id" class="linecon" :class="{back_color:(index+1)%2==0}">
                                        <el-tooltip placement="top" effect="light">
                                            <p style="width:60%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.replyContent}}</p>
                                            <div slot="content">
                                                  {{item.replyContent}}
                                            </div>
                                        </el-tooltip>
                                        <div style="width:40%;text-align:right;white-space: nowrap;">
                                            <span class="search_btn" @click="edicontent(item.id+'',item.replyId+'')" ><i class="el-icon-edit-outline" title="编辑"></i></span>
                                            <span class="search_btn" @click="deletecontent(item.id+'')"><i class="el-icon-delete" title="删除"></i></span>
                                            <span class="search_btn" @click="beforeSend(item.replyContent)"><i class="el-icon-edit" title="预编辑"></i></span>
                                            <span class="search_btn" @click="clickSend(item.replyContent)"><i class="el-icon-s-promotion" title="发送"></i></span>
                                        </div>
                                   </div>
                                </div>

                          </div>
                      </div>

                  </el-tab-pane>
                  <el-tab-pane label="公共库" class="library" name="0">
                      <div class="personseach">
                        <input placeholder="请输入关键词搜索" v-model="seachpublicwords"/>
                        <i data-v-d2fd4914="" class="el-input__icon el-icon-search" style="height:40px;position:absolute;" @click="searchfast"></i>
                      </div>
                      <div class="quickreply">
                          <div class="classify">
                                <div class="classify-title">分类</div>
                                <div class="classify-con" :style="classifyHeight" >
                                  <div class="ztree" id="sortpublicTree"></div>
                                </div>
                          </div>
                          <div class="content">
                                <div class="content-title">
                                  内容
                                  <Button type="primary" size="small" :disabled="selectedTreeName == '根目录'" @click="addcontent" style="float:right;margin-top:10px">添加话术</Button>
                                </div>
                                <div class="content-con" :style="classifyHeight">
                                    <div v-for="(item, index) in contentGroup" :key="index" :id="item.id" class="linecon" :class="{back_color:(index+1)%2==0}">
                                        <el-tooltip placement="top" effect="light">
                                            <p style="width:60%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.replyContent}}</p>
                                          <div slot="content">
                                                {{item.replyContent}}
                                          </div>
                                        </el-tooltip>
                                        <div style="width:40%;text-align:right;white-space: nowrap;">
                                            <span class="search_btn" @click="edicontent(item.id+'',item.replyId+'')"><i class="el-icon-edit-outline" title="编辑"></i></span>
                                            <span class="search_btn" @click="deletecontent(item.id+'')"><i class="el-icon-delete" title="删除"></i></span>
                                            <span class="search_btn" @click="beforeSend(item.replyContent)" ><i class="el-icon-edit" title="预编辑"></i></span>
                                            <span class="search_btn" @click="clickSend(item.replyContent)" ><i class="el-icon-s-promotion" title="发送"></i></span>
                                        </div>
                                   </div>
                                </div>
                          </div>
                      </div>
                  </el-tab-pane>
                </el-tabs>
            </TabPane>

       </Tabs>
       <AddsortPop :showAddsort="showAddsort" @closesort="closesort" :sortId="sortId" :judgeId="judgeId" :title="title"  :replyType="replyType" :selectedTreeId="selectedTreeId" :zreid="zreid"></AddsortPop>
    </Card>
  </div>
</template>

<script>
 import {publicFunClass} from '@/components/js/PublicFunClass.js'
 import AddsortPop from '@/components/OnlineService/AddsortPop.vue'
 import File from '@/components/customerMange/File.vue'
 import eventBus from "../../util/eventBus";
  export default {
    name: "OnlineRightcon",
    mixins:[publicFunClass],
    props:{
      openId: String,
    },
    components:{
      AddsortPop,
      File,
    },
    data() {
      return {
        forbidden:false,
        tabRig:'1',
        date1: '',
        classifyHeight:{},
        heightStyle:{'height':'','overflow-y':'auto','overflow-x':'hidden'},
        sysSupportWorkOrder: JSON.parse(localStorage.getItem("sysSupportWorkOrder")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
        callUuid:'',
        showColumnList:null,
        customerId:'',
        editable:false,


        visitorFrom:'',
        ipArea:'',
        customerManager:'',
        browseUrl:'',
        visitedtimes:'',
        trajecnumList:[],


        showAddsort:false,
        inspectData:[{'id':'1','name':'问候语'},{'id':'2','name':'结束语'},{'id':'3','name':'礼貌词'}],
        sortId:'',
        judgeId:'',
        title:'',
        // sortGroup:[{'id':'1','name':'问候语'},{'id':'2','name':'结束语'},{'id':'3','name':'礼貌词'}],
        contentGroup:[],
        selectedTreeId:'',
        inspectTreeData:[],
        replyType:'1',
        librarytype:'1',
        seachwords:'',
        seachpublicwords:'',
        selectedsubId:'',
        sessionChannel: '',
        visible: false, //客户隐藏字段是否显示
        visibleService: false, //服务隐藏字段是否显示

        randomcode:'',
        selectedTreeName:'根目录',
        zreid:'',
        tabName:"1",
        sessionId:'',
        isClickWork:false,
      }
    },
    mounted(){
      this.bindEvents();
    },
    created(){
      this.classifyHeight.height=this.mountHeight(270);
      this.heightStyle.height=this.mountHeight(128);
      this.tabName = "1";
      this.initSearchcus();
      this.initSearchcusbasic();

    },
    destroyed() {
      eventBus.$off('updateCustom');
      eventBus.$off('updateCustomFromOtherAgent');
    },
    methods: {
        bindEvents:function(){
          let that = this
          eventBus.$on('updateCustom', function (msg) {
            that.showColumnList = msg;
          });
          eventBus.$on('updateCustomFromOtherAgent', function (openId,sessionId) {
            that.searchCustomInfo(openId,sessionId);
          });
        },
        changlib:function(){
            this.contentGroup=[];
            this.selectedTreeName = '根目录';
            if('1' == this.librarytype){//个人库
              this.replyType="1";
              this.initsortSearch();
            }else if('0' == this.librarytype){//公共库
               this.replyType="0";
               this.initsortSearch();
            }
        },
      changeTabrig:function(name){
        let that=this;
        this.tabName = name;
        if('1' == name){
          this.tabRig = '1';
          this.initSearchcusbasic();
          this.$forceUpdate();
        }else if('2' == name){
          let param={
            openId:this.openId,
            journalType:"null",
            menuId:"null"
          };
          this.$http.post("chatInterface/toConversationDetail.json",param) .then(function (res) {
            let result=res.data.flag;
            that.spinShow=false;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.trajecnumList = [];
            that.visitorFrom=res.data.obj.detailObj.visitorFrom;
            that.ipArea=res.data.obj.detailObj.ipArea;
            that.customerManager=res.data.obj.detailObj.customerManager;
            that.browseUrl=res.data.obj.detailObj.browseUrl;
            that.visitedtimes=res.data.obj.trackList.length;
            that.trajecnumList = res.data.obj.trackList;

          });
        }else if('3' == name){
          this.initsortSearch();
        }else if('4' == name){
          this.$emit("openwo",true);
        }
        this.$store.commit('pushOnlineRightInfo',this.showColumnList);
      },
      //客户资料查询--------------
        initSearchcus:function () {
           this.showColumnList = {
              "customerId": '', //客户id
              "serviceId": '', //服务id
              "columnList":[], //客户显示列
              "serviceList":[], //服务记录字段
              "serviceRule":{}, //服务记录是否必填、唯一规则
              "customerRule":{}, //客户是否必填、唯一规则
              "customerList":{}, //客户列表
            }
        },
        // 数据初始化
        init: function(){
          let onlineInfo = this.$store.getters.getOnlineInfoByOpenId(this.openId);
          if(onlineInfo){
            this.sessionId = onlineInfo.sessionId;
            if(!onlineInfo.rightInfo.openId){
              // 查询客户
              this.initSearchcusbasic();
            }else{
              this.showColumnList = JSON.parse(JSON.stringify(onlineInfo.rightInfo));
              // this.showColumnList["serviceList"] = this.getListValue([],this.showColumnList["serviceList"]);
            }
            if(this.tabName == '2'){
              this.changeTabrig("2");
            }
            this.sessionChannel = onlineInfo.sessionChannel;
          }else{
            this.sessionChannel = "";
            this.initSearchcusbasic();
          }
        },
        // 远程客户信息查询
        searchCustomInfo(openId,sessionId){
          let onlineInfo = this.$store.getters.getOnlineInfoByOpenId(openId);
          if(!onlineInfo){
            return;
          }
          let that=this;
          let param={
            openId:this.openId ? this.openId : "-1",
            journalType:"null",
            menuId:"null",
            sessionId:sessionId,
          };
          this.$http.post("chatInterface/doSelectOne.json",param) .then(function (res) {
            let fieldList = res.data.obj.fields;
            let customerList = res.data.obj.list.content;  //客户列表数据
            //  字段处理
            let columnList=[];
            let customerRule={};
            for (let i=0;i<fieldList.length;i++){
              let customColName=fieldList[i].customColName;
              let customName=fieldList[i].customName;
              let customType=fieldList[i].customType;
              let customIsMust=fieldList[i].customIsMust;
              let customIsShow=fieldList[i].customIsShow;
              let customIsAlter=fieldList[i].customIsAlter;
              let listData=fieldList[i].list;
              if(!listData){
                listData=[];
              }
              let columnParam={
                type: customType,
                customColName: customColName,
                customValue:fieldList[i].customType=='cascade'?[]:'',
                customIsMust:customIsMust,
                customIsShow:customIsShow,
                customName:customName,
                customIsAlter:customIsAlter,
                customOrigin:'',  //原始的字段信息，比如手机号码，会存放不加密的号码
                list:listData,
              };
              columnList.push(columnParam);
              let list= [{ required: true}];
              if(customIsMust=='1'){
                customerRule[customColName]=list;
              }
            }
            let showColumnList = [];
            showColumnList["customerId"] = "";
            if(customerList.length > 0){
              showColumnList["customerId"] = customerList[0].id;
              let onlineInfo = that.$store.getters.getOnlineInfoByOpenId(openId);
              if(onlineInfo){
                // 赋值客户类型
                onlineInfo.customerType = customerList[0].customerType;
              }
            }
            showColumnList["orderId"] = res.data.obj.orderId;
            showColumnList["columnList"]=that.getListValue(customerList[0],columnList);
            showColumnList["customerRule"]=customerRule;
            showColumnList["customerList"] = customerList;
            showColumnList['openId'] = openId;
            that.$store.commit('pushOnlineRightInfo',showColumnList);
            if(that.openId == openId){
              that.$emit("closeWoPop");
              that.$Message.info({
                content: "会话信息同步，请稍候……",
                duration: 2
              });
              setTimeout(function () {
                that.initSearchcusbasic(true);
              },1000);
            }
          });
        },
        // 客户信息查询
        initSearchcusbasic:function (flag) {
            let onlineInfo = this.$store.getters.getOnlineInfoByOpenId(this.openId);
            if(onlineInfo && !flag){
              if(onlineInfo.rightInfo.openId){
                return;
              }
            }
            let that=this;
            let param={
              openId:this.openId ? this.openId : "-1",
              journalType:"null",
              menuId:"null",
              sessionId:this.sessionId,
            };
            this.$http.post("chatInterface/doSelectOne.json",param) .then(function (res) {
              let result=res.data.flag;
              that.spinShow=false;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
            let fieldList = res.data.obj.fields;
            let customerList = res.data.obj.list.content;  //客户列表数据
            //  字段处理
             let columnList=[];
             let customerRule={};
             for (let i=0;i<fieldList.length;i++){
               let customColName=fieldList[i].customColName;
               let customName=fieldList[i].customName;
               let customType=fieldList[i].customType;
               let customIsMust=fieldList[i].customIsMust;
               let customIsShow=fieldList[i].customIsShow;
               let customIsAlter=fieldList[i].customIsAlter;
               let customIsSystem=fieldList[i].customIsSystem;
               let listData=fieldList[i].list;
               if(!listData){
                 listData=[];
               }
               // let isModifyManager=that.configInfo.isModifyManager;
               // if(customerList.length!=0 && customColName=='customerManager'){
               //   customIsAlter=isModifyManager;
               // }
               let columnParam={
                 type: customType,
                 customColName: customColName,
                 customValue:fieldList[i].customType=='cascade'?[]:'',
                 customIsMust:customIsMust,
                 customIsShow:customIsShow,
                 customName:customName,
                 customIsAlter:customIsAlter,
                 customIsSystem:customIsSystem,
                 customOrigin:'',  //原始的字段信息，比如手机号码，会存放不加密的号码
                 list:listData,
               };
              columnList.push(columnParam);
               let list= [{ required: true}];
               if(customIsMust=='1'){
                 customerRule[customColName]=list;
               }
             }
              let onlineInfo = that.$store.getters.getOnlineInfoByOpenId(that.openId);
              that.showColumnList["customerId"] = "";
             if(customerList.length > 0){
              that.showColumnList["customerId"] = customerList[0].id;
              if(onlineInfo){
                // 赋值客户类型
                onlineInfo.customerType = customerList[0].customerType;
              }
             }
             that.showColumnList["orderId"] = res.data.obj.orderId;
             that.showColumnList["columnList"]=that.getListValue(customerList[0],columnList);
             that.showColumnList["customerRule"]=customerRule;
             that.showColumnList["customerList"] = customerList;
             if('0' == that.configInfo.isHiddenService){
               //  客户查询结束，查询服务
               if(flag){
                 //刷新客户不刷服务记录
                 return;
               }
               that.initSearchcusservice();
             }else{
               that.showColumnList["serviceList"] = [];
               that.showColumnList["serviceRule"] = [];
               that.showColumnList["agentUUid"] = that.callUuid;
               if(that.openId){
                 that.showColumnList['openId'] = that.openId;
                 that.$store.commit('pushOnlineRightInfo',that.showColumnList);
                 //  再次从store中取的showColumnList的值，否则更新store的值，页面不会发生变化
                 that.init();
               }
             }
            });
        },
        //服务查询
        initSearchcusservice:function () {//服务查询
            let that=this;
            let param={
              type: '1',
              callUuid: this.openId ? this.openId : '-1',  //callUuid是对应的openId，因为不修改getTableInfo接口，所以用这个字段
              journalType:"null",
              menuId:"null"
            };
            this.$http.post("popUp/getTabInfo.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let fieldList=res.data.obj.fields;
              let contentList=res.data.obj.list.content;
              let columnList=[];
              let serviceRule={};
             for (let i=0;i<fieldList.length;i++){
               let customColName=fieldList[i].customColName;
               if(customColName.indexOf('customerId') != -1 || customColName.indexOf('telephone') != -1){
                 continue;
               }
               let customName=fieldList[i].customName;
               let customType=fieldList[i].customType;
               let customIsMust=fieldList[i].customIsMust;
               let customIsAlter=fieldList[i].customIsAlter;
               let customIsShow = fieldList[i].customIsShow;
               let customIsSystem = fieldList[i].customIsSystem;
               let listData=fieldList[i].list;
               if(!listData){
                 listData=[];
               }
               let columnParam={
                 type: customType,
                 customColName: customColName,
                 customValue: fieldList[i].customType=='cascade'?[]:'',
                 customIsMust:customIsMust,
                 customName:customName,
                 customIsAlter:customIsAlter,
                 customIsShow: customIsShow,
                 customIsSystem: customIsSystem,
                 customOrigin:'',
                 list:listData,
               };
               columnList.push(columnParam);
               let list= [{ required: true}];
               if(customIsMust=='1'){
                 serviceRule[customColName]=list;
               }
             }
             that.showColumnList["serviceList"] = that.getListValue(contentList[0],columnList);
             that.showColumnList["serviceRule"] = serviceRule;
             that.showColumnList["agentUUid"] = that.callUuid;
             if(that.openId){
               that.showColumnList['openId'] = that.openId;
               that.$store.commit('pushOnlineRightInfo',that.showColumnList);
              //  再次从store中取的showColumnList的值，否则更新store的值，页面不会发生变化
               that.init();
             }
            });

        },

        getSaveParam:function(columnList){
           let param={
             journalType:"在线客服客户信息保存",
             menuId:"null",
             id:'',
             callUuid:this.callUuid
           };
           for (let i=0;i<columnList.length;i++){
             let customValue=columnList[i].customValue;
             let customIsMust=columnList[i].customIsMust;
             let customName=columnList[i].customName;
             let customColName=columnList[i].customColName;
             if(customIsMust=='1' && customColName!='customerId' && customColName!='employeeId'){
               if (!customValue){
                 this.$Message.info(customName+"不能为空");
                 return false;
               }
             }
             if(customColName.indexOf("file") != -1 && customValue){
                // 如果下载地址是空的，保存时去除这行数据
                let fileJson = JSON.parse(customValue);

                for(let n = 0; n < fileJson.length; ){
                  if (!fileJson[n].downloadAddr){
                    fileJson.splice(n,1);
                  }else{
                    n++;
                  }
                }
                customValue = JSON.stringify(fileJson);
              }

            //  手机号码字段，且 号码隐藏的，不隐藏的不用替换
             if(customColName.indexOf("telephone") != -1){
               if(customValue && customValue.indexOf("*") != -1){
                 customValue= columnList[i].customOrigin;//原始的字段信息，比如手机号码，会存放不加密的号码
               }else{
                 //不隐藏号码情况下修改了号码
                 if(customValue && isNaN(customValue)){  //包含非数字
                   customValue = customValue.replace(/[^0-9]/ig,"");
                 }
               }
             }
             let type=columnList[i].type;
             if (!customValue){
               customValue="";
             }
             if(type=="datetime" && customValue){
               if(!(/^[\d\s-]+/.test(customValue))){
                 customValue=this.timeChange(customValue);
               }
             }


             param[columnList[i].customColName]=customValue;
           }
           return param;
         },

      getListValue:function (contentList,list) {
        let phoneIsHide= this.configInfo.phoneIsHide;
        for (let i=0;i<list.length;i++){
          let customColName=list[i].customColName;
          let type=list[i].type;
          for (let key in contentList){
            let value=contentList[key];
            if(customColName==key){
              list[i].customValue=value;

              if(type=='checkbox' || type=='radio' || type=='select' || type =='cascade'){
                list[i].customValue=contentList[key+"Id"];
              }
            }
          }
          // 对系统的禁用的字段进行处理
          if(list[i].customIsSystem == '1' && (type=='checkbox' || type=='radio' || type=='select')){
                if(list[i] && list[i].list){
                  list[i].list = list[i].list.filter(item => item.isClose == '1' || !item.isClose);
                }
          }
          if(customColName.indexOf('telephone') != -1){
            list[i].customOrigin = list[i].customValue;//原始的字段信息，比如手机号码，会存放不加密的号码
            if(phoneIsHide=='1' && contentList){
              list[i].customValue=contentList[customColName+"Hide"];
            }
          }
          if(customColName=="employeeName"){
            list[i].customValue=this.agentInfo.employeeName;
          }
          //新客户默认客户经理
          if(customColName=="customerManager" && !list[i].customValue){
            list[i].customValue=this.agentInfo.employeeId;
          }
          // 如果是服务渠道，在这里默认为传来的渠道
          if(customColName == "serviceChannel") {
            if(list[i].list.find(item => item.id == this.sessionChannel)){  //传来的渠道不被禁用，才默认给传来的渠道
              list[i].customValue = this.sessionChannel;
            }
          }
        }
        return list
      },
      saveCustomerServiceInfo:function(param,flag){
          //  param.id="";
           if(param.id == "-1"){
             param.id = "";
           }
           param.isHiddenService = this.configInfo.isHiddenService;
           let that=this;
           this.loading = false;
           this.$http.post("chatInterface/doSaveCustAndService.json",param) .then(function (res) {
             that.customerResult=res.data.flag;
             that.loading = false;
             if(res.data.flag!="666"){
               that.$Modal.info({
                 title: '提示',
                 content: res.data.msg
               });
               return false;
             }
             if(flag){
               //同步保存工单
               that.$emit('workOrderBack');
             }else{
               //仅保存客户。但同步更新工单
               that.$emit('workOrderBack',true);
               that.$Message.info("客户信息保存成功");
             }
            that.initSearchcusbasic(true);
            that.showColumnList["customerId"] = res.data.obj;
            that.showColumnList["serviceId"] = res.data.msg;
            that.$store.commit('pushOnlineRightInfo',that.showColumnList);
           });
         },
        //调用接口确认是否是第一次保存，非第一次需进行弹窗提示
        beforeSave:function(flag){
          let that=this;
          let param={
            journalType:"null",
            menuId:"null",
            openId:this.openId,
            customerId:this.showColumnList.customerId
          };
          this.$http.post("chatInterface/doCheckFirstSaveAction.json  ",param) .then(function (res) {
            let result=res.data.flag;
            that.spinShow=false;
            if(result!="666"){
              that.$confirm('当前会话已绑定客户，是否更换绑定客户？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(() => {
                that.confirmSave();
              }).catch(() => {
                //静默刷新客户
                that.initSearchcusbasic(true);
              });
              return false;
            }
            if(flag){
              that.save(true);
              return false;
            }
            that.confirmSave();
          });
        },
        //提示确认是否保存工单
        confirmSave:function(){
          this.$store.commit('pushOnlineRightInfo',this.showColumnList);
          let onlineInfo = this.$store.getters.getOnlineInfoByOpenId(this.openId);
          let workOrderInfo = onlineInfo.workOrderInfo;
          if(workOrderInfo && (!workOrderInfo.workId || '-1' == workOrderInfo.workId)){
            this.$confirm('是否保存工单？', '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            }).then(() => {
              this.save(true);
            }).catch(() => {
              this.save(false);
            });
          }else{
            this.save(false);
          }
        },
         save:function(flag){//保存
          // 将客户列表字段和服务列表字段拼接成一个json字符串传给后端
          let columnList=this.showColumnList.columnList.concat(this.showColumnList.columnList).concat(this.showColumnList.serviceList);
          let param=this.getSaveParam(columnList);
               if(!param){
                 return false;
               }
               param["serviceId"] = this.showColumnList["serviceId"]; //把服务记录的id传进去
               param.id = this.showColumnList["customerId"];
               param["openId"] = this.openId;
               param["callUuid"] = this.$store.getters.getOnlineInfoByOpenId(this.openId).sessionId;
               this.saveCustomerServiceInfo(param,flag);
         },
        //--------------------------------
        //快捷回复--------------------------
        initSortTree:function () {//树初始化
            let that=this;
            let setting = {
              view: {
               addHoverDom: addHoverDom, //当鼠标移动到节点上时，显示用户自定义控件
               removeHoverDom: removeHoverDom, //离开节点时的操作
                dblClickExpand: false,
                showLine: true,
                selectedMulti: false
              },
               edit: {
                  enable: true, //单独设置为true时，可加载修改、删除图标
                  editNameSelectAll: true,
                  showRemoveBtn: false,
                  showRenameBtn: showRenameBtn,
                  renameTitle:'编辑'
              },
              data: {
                simpleData: {
                  enable:true,
                  idKey: "id",
                  pIdKey: "pid",
                  rootPId: ""
                },
                key:{
                  name:"replyClassName"
                }
              },
              callback: {
                onClick: zTreeOnClick,//单击事件
                onRename: onRename //修改事件

              }
            };

            function  showRenameBtn(treeId, treeNode){
              if(treeNode.id =='0'){
                return false;
              }else{
                return true;
              }
            }

            function addHoverDom(treeId,treeNode){
                var sObj = $("#" + treeNode.tId + "_span");
                if (treeNode.editNameFlag || $("#addBtn_"+treeNode.tId).length>0) return;
                var addStr = "<i class='el-icon-circle-plus' id='addBtn_" + treeNode.tId
                    + "' title='添加子分类' onfocus='this.blur();'></i>";
                sObj.after(addStr);
                var btn = $("#addBtn_"+treeNode.tId);
                if (btn) btn.bind("click", function(){
                  that.createCode();
                  let name='新分类'+ that.randomcode;
                  that.saveSubcate(treeNode.id,name);
                    //在这里向后台发送请求保存一个新建的叶子节点，父id为treeNode.id,让后将下面的100+newCount换成返回的id
                    //zTree.addNodes(treeNode, {id:(100 + newCount), pId:treeNode.id, name:"新建节点" + (newCount++)});
                    return false;
                });
            }
            function removeHoverDom(treeId,treeNode){
                $("#addBtn_"+treeNode.tId).unbind().remove();
            }


            function zTreeOnClick(event,treeId,treeNode) {
              that.selectedTreeName = treeNode.replyClassName;
              that.selectedTreeId=treeNode.id;;
              that.selectedsubId=treeNode.subId;
              that.searchcontent(treeNode.subId);
            }


            function onRename(event, treeId, treeNode, isCancel) {
                if(treeNode.pid==""){
                    treeNode.pid="0";
                }
                that.editsort(treeNode.id,treeNode.pid,treeNode.replyClassName);
               // $.post('./index.php?r=data/modifyname&id='+treeNode.id+'&name='+treeNode.name);
            }
            let zNodes =this.inspectTreeData;
            if(this.replyType=="1"){
              if (zNodes){
                $(document).ready(function(){
                      let zTree=$.fn.zTree.init($("#sortTree"), setting, zNodes);
                      //t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
                      zTree.expandAll(true);
                      let nodes = zTree.getNodes();
                      if (nodes.length > 0) {
                        zTree.selectNode(nodes[0]);//默认选中根节点
                      }
                });
              }
            }else if(this.replyType=="0"){
              if (zNodes){
                $(document).ready(function(){
                      let zTree=$.fn.zTree.init($("#sortpublicTree"), setting, zNodes);
                      zTree.expandAll(true);
                      let nodes = zTree.getNodes();
                      if (nodes.length > 0) {
                        zTree.selectNode(nodes[0]);//默认选中根节点
                      }
                });
              }
            }

        },
        initsortSearch:function () {//查询右侧类(开始一进来为个人类)
            let param={
              replyType:this.replyType,
              agentNumber:this.agentInfo.agentNumber,
              meanType:'0'
            };
            let that=this;
            this.$http.post("chatReply/toSelectChatReplyDetail.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let list=res.data.obj.list;
              let agentNumber = that.agentInfo.agentNumber;
              if('0' == that.replyType){
                agentNumber = '';
              }
              let paramTwo={
                agentNumber:agentNumber,
                id:'0',
                pid:'null',
                replyClassName:'根目录',
                replyType:that.replyType
              };
              list.push(paramTwo);
              that.inspectTreeData =list;
              for (let i=0;i<list.length;i++){
                let pid=list[i].pid;
                if(pid=="0"){
                  that.selectedTreeId=list[i].id;
                  //
                  // that.searchcontent(list[i].id);
                }
              }
              that.initSortTree();
            });
        },

        saveSubcate:function(ids,name){ //添加子分类
            let param={
              agentNumber:this.agentInfo.agentNumber,
              id:'',
              pid:ids,
              replyClassName:name,
              replyType:this.replyType,
              meanType:'0',
              journalType:"在线客服=>快捷回复=>添加类目",
              menuId:"3_12-4-1"
            };
            let that=this;
            this.$http.post("chatReply/doReplySave.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.info("新增成功");
              setTimeout(function () {
                 that.initsortSearch();
              },2000);

            });
          },
        searchcontent:function (ids) {//查询话术内容
            if(!ids){
                  ids="";
            }
            let param={
                subId:ids,
                replyType:this.replyType,
                meanType:'0',
                // agentNumber:this.agentInfo.agentNumber,
            };
            let that=this;
            this.$http.post("chatReply/toSelectReplyRelationInfo.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.contentGroup=res.data.obj.list.content;
            });
        },
        editsort:function(id,pid,name){      //编辑分类
                let that=this;
                let param={
                  id:id,
                  pid:pid,
                  replyClassName:name,
                  replyType:this.replyType,
                  meanType:'0',
                  agentNumber:this.agentInfo.agentNumber,
                  journalType:"在线客服=>快捷回复=>编辑类目",
                  menuId:"3_12-4-2"
                };

                this.$http.post("chatReply/doReplySave.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$Modal.info({
                      title:'提示',
                      content:res.data.msg
                    });
                    setTimeout(function () {
                      that.initsortSearch();
                    },3000);
                    return false;
                  }
                  that.$Message.info("保存成功");
                  that.closesort(true);
                });
        },
        //搜索快捷词
        searchfast:function(){
          let chooseword;
          if(this.replyType=="1"){
              chooseword=this.seachwords;
          }else if(this.replyType=="0"){
              chooseword=this.seachpublicwords;
          }
            let param={
              subId:this.selectedsubId,
              replyContent:chooseword,
              replyType:this.replyType,
              meanType:'0'
            };
            let that=this;
            this.$http.post("chatReply/toSelectReplyRelationInfo.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.contentGroup=res.data.obj.list.content;
            });
        },

	      addsort:function(){//
            this.showAddsort=true;
            this.title="添加分类";
            this.sortId="";
            this.judgeId="";
            // let newsort=[];
            // this.sortGroup.push(newsort);
        },
        addcontent:function(){//
            this.showAddsort=true;
            this.title="添加话术";
            this.sortId="";
            this.judgeId="1";
        },
        edicontent:function(ids,reids){//
            this.showAddsort=true;
            this.title="编辑话术";
            this.sortId=ids;
            this.judgeId="1";
            this.zreid=reids;
        },
        beforeSend:function(content){
         if(this.openId){
           eventBus.$emit('beforeSend',content);
         }
        },
        clickSend:function(content){
          if(this.openId) {
            eventBus.$emit('clickSend', content);
          }
        },
        deletecontent:function(ids){//删除话术内容
            let param={
                id:ids,
                replyType:this.replyType,
                meanType:'0',
                journalType:"在线客服=>快捷回复=>删除话术",
                menuId:"3_12-4-6"
              };
            let that=this;
            this.$Modal.confirm({
              title: '提示',
              content:'是否确定删除',
              onOk:()=>{
                that.$http.post('chatReply/doDeleteRelation.json',param).then(res=>{
                      let response = res.data
                      if (response.flag !== '666') {
                        that.$alert(response.msg,'提示',{
                          confirmButtonText:'确定'
                        })
                        return false
                      }
                      that.$Message.info('删除成功');
                      //this.initsortSearch();
                      this.searchcontent(this.selectedsubId);
                })
              }
            })
        },
        closesort:function(flag,num){
            this.showAddsort=false;
            if(flag && num=='1'){
              //this.searchcontent(that.selectedsubId)
              this.searchcontent(this.selectedsubId);
            }else if(flag){
              this.initsortSearch();
            }
        },
        handleOpen:function () {
          this.visible = !this.visible;
         },
        handleOpenService:function () {
          this.visibleService = !this.visibleService;
         },
         //随机数
         createCode:function () {
              let code = '';
              let codeLength = 4;
              let random = new Array(0, 1, 2, 3, 4,5, 6, 7, 8, 9);
              for (let i = 0; i < codeLength; i++) {
                  let index = Math.floor(Math.random() * 9);
                  code += random[index];
              }
              this.randomcode = code;

         },
         // 上传文件过程中不能保存，调用的接口
          fileUploadCallback(flag){
            if(flag || flag == 'true'){
              this.loading = true;
            }else{
              this.loading = false;
            }
          }
    },
    watch: {

      // 监听左侧点击客户列表时openId的变化，变化了要重新获取聊天记录
      // 聊天记录如果是座席发，name值是座席名称，如果不是座席发，显示客户名称（群聊情况下，本座席发在右边，访客和其他座席发在左边）
      openId(){
        this.init();
      },
    }
  }
</script>
<style scoped lang="less">
.ivu-form-item-error .ivu-input{
  border: 1px solid #dcdee2 !important;
}
.rightdata{
  .ivu-form-item-error{
    .ivu-input{
      border: 1px solid #dcdee2 !important;
    }
    .ivu-select-selection{
      border: 1px solid #dcdee2 !important;
    }
  }
  .infor-form{
    .input_style{
      width: 100%;
      display: flex;
      height: 50px;
      .font_style_set{
        width: 160px;
        text-align: right;
        line-height: 50px;
      }
      .ivu-input-wrapper{
        // width: 500px;
        margin-left: 16px;
        padding-top: 9px;
        .ivu-input{
          border-radius: 1px;
        }
      }
      .el-date-editor{
        margin-left: 16px;
        padding-top: 5px;
      }

    }
  }
  .library{
       width: 100%;
      .personseach{
        width:96%;
        margin:0 auto;
        height: 40px;
        padding:0 4%;
        background:#f5f7fa;
        input{
            width:90%;
            height: 40px;
            line-height:40px;
            background:#f5f7fa;
            position:relative;
            border:none;
        }
      }
      .quickreply{
        //overflow: hidden;
        overflow: visible;
        width: 100%;
         .classify{
            float:left;
            width: 45%;
            .classify-title{
              height: 50px;
              line-height: 50px;
              color: #676d77;
              font-size: 15px;
              padding-left:10px;
            }
            .classify-con{
              border: 1px solid #edf3f8;
              height: 100%;
             // width:100%;
              overflow:auto;
              ul{
                list-style: none;
                li{
                    background:#f5f7fa;
                    color: #676d77;
                    font-size: 12px;
                    height: 30px;
                    line-height: 30px;
                    letter-spacing: 2px;
                    padding-left:10px;
                    border: 1px solid #edf3f8;
                }
              }
            }
         }
         .content{
            float: right;
            width: 55%;
            .content-title{
               height:50px;
              line-height: 50px;
              color: #676d77;
              font-size: 15px;
              border-bottom: 1px solid #edf3f8;
            }
            .content-con{
                    border: 1px solid #edf3f8;
                    width:100%;
                    overflow-y:auto;
                    .search_btn{
                      color: #2d8cf0;
                      cursor: pointer;
                    }
                    .search_btn:hover{
                      color: blue;
                    }
                     .linecon{
                       width:100%;display:flex;justify-content:space-between;
                     }
                     .linecon:hover{
                            background-color: #57a3f352;
                      }
            }
         }

         .footeradd{
           border: 1px solid #edf3f8;
           height: 50px;
           line-height: 50px;
           text-align: center;
           z-index:99;
         }
      }


  }
}

// 右边数据样式
.rightForm{
  margin-top:50px;
}
.rightForm .ivu-form-item{
  margin-left: 1%;
  margin-right: 1%;
  width: 100%;
  display: flex;
  margin-bottom: 10px;
}

.rightForm /deep/ .ivu-form-item-label{
    height: 30px;
    width: 25%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.rightForm /deep/ .ivu-form-item-content{
  width: 70%;
  .el-cascader{
    width: 100%;
  }
}
.rightForm /deep/ .el-input{
  width: 100%;
}
.rightForm /deep/ .el-input__inner{
  height: 30px;
}
.rightForm /deep/ .el-input__icon{
  line-height: 33px;
}
.rightForm /deep/ input:focus{
    border: 1px solid #57a3f3;
    box-shadow: 0 0 5px #57a3f3 !important;
    //box-shadow: 3px 3px 10px #a7a7a9;
}
.rightForm /deep/ input:click{
  border: 1px solid #57a3f3;
  box-shadow: 0 0 5px #57a3f3 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OnlineService/OnlineRightcon.vue